import * as React from 'react';



export default class CloseFilled extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg stroke="none" className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
       <g fill="none" stroke="none" fillRule="evenodd">
            <circle cx="8" cy="8" r="8" fill="#ECECEC"/>
            <g stroke="#979797" strokeLinecap="round" opacity=".6">
                <path d="M5.072 5.072l5.833 5.833M5.072 10.905l5.833-5.833"/>
            </g>
        </g>
      </svg>
    )
  }
}
